module.exports = __webpack_public_path__ + "static/media/external-link.cb6a1d77.svg";